var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLedThermometer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.8a.6.6 0 01.6.6v6.076a2.4 2.4 0 11-1.2 0V6.401a.6.6 0 01.6-.6z",
    fill: "#FFA700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 .4A3.6 3.6 0 001.4 4v7.625a4.8 4.8 0 107.2 0V4A3.6 3.6 0 005 .4zm0 1.2A2.4 2.4 0 017.4 4v8.106l.172.174a3.6 3.6 0 11-5.143 0l.171-.174V4A2.4 2.4 0 015 1.6z",
    fill: "#FFA700"
  })));
}
export default SvgLedThermometer;